import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import changeQtyOrderedWholegoods from "@store/Store/Pages/ProductDetails/Wholegoods/Handlers/ChangeQtyOrderedWholegoods";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    product?: ProductModel;
}

const mapStateToProps = (state: StoreApplicationState, { product }: OwnProps) => {
    return {
        productInfo: product ? state.store.pages.productDetailsWholegoods.productInfosByProductId[product.id] : undefined,
    };
};

const mapDispatchToProps = {
    changeQtyOrderedWholegoods,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const StoreWholegoodProductContext: FC<Props> = ({ product, productInfo, children, changeQtyOrderedWholegoods }) => {
    if (product && productInfo) {
        const productContext: ProductContextModel = {
            product,
            productInfo,
            onQtyOrderedChanged: qtyOrdered => changeQtyOrderedWholegoods({ productId: product.id, qtyOrdered }),
        };

        return <ProductContext.Provider value={productContext}>{children}</ProductContext.Provider>;
    }

    return <>{children}</>;
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreWholegoodProductContext);
